export { default as InputTextList } from './InputTextList';



// WEBPACK FOOTER //
// ./src/components/FormControls/InputTextList/index.ts